<script>
export default {
    name: "mine",
    data() {
        return {
            menu: [
                { text: '用户信息', url: '/mine/userinfo' },
                { text: '修改密码', url: '/mine/updataPwd' },
                { text: '我的订单', url: '/mine/order' },
                { text: '我的会员', url: '/vip' },
                { text: '我的发票', url: '/mine/invoice' },
                { text: '收货地址', url: '/mine/address' },
                { text: '退款管理', url: '/mine/refund' },
            ]
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        // 登出
        logout() {
            if (confirm('是否确认登出？')) { 
                localStorage.removeItem('token');
                this.$router.push('/login');
            }
        },
    },
};
</script>

<template>
    <div class="mine">
        <div class="banner layout_bg"></div>
        <div class="wrapper layout_main flex">
            <div class="menu">
                <div class="item" v-for="(item, index) in menu" :key="index">
                    <router-link :to="item.url">{{ item.text }}</router-link>
                </div>
                <div class="item">
                    <a href="javascript:;" @click="logout">登出</a>
                </div>
            </div>
            <div class="content">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.mine{
    .banner{
        width: 100%;
        height: 4.8rem;
        background-color: rgba($color: #000000, $alpha: .5);
    }
    .wrapper{
        padding: .4rem 0;
        @media only screen and (max-width: 750px) {
            padding: 0;
            display: block;
            width: 100%;
        }
    }
    .menu{
        width: 2.3rem;
        flex-shrink: 0;
        padding-left: .45rem;
        @media only screen and (max-width: 750px) {
            width: 100%;
            border-bottom: 1px solid #999;
            border-top: 1px solid #999;
            display: flex;
            padding: 0 .3rem;
            overflow-x: auto;
            gap: .56rem;
        }
        .item{
            font-size: .16rem;
            color: #999;
            margin-bottom: .2rem;
            a{
                &:hover,
                &.active{
                    color: var(--font_color);
                    border-bottom: 1px solid var(--font_color);
                }
            }
            @media only screen and (max-width: 750px) {
                font-size: .25rem;
                white-space: nowrap;
                margin-bottom: 0;
                height: .86rem;
                line-height: .86rem;
                a{
                    display: inline-block;
                    &:hover,
                    &.active{
                        border-bottom: none;
                    }
                    &:hover{
                        color: #999;
                    }
                    &.active{
                        color: var(--font_color);
                    }
                }
            }
        }
    }
    .content{
        flex: 1;
        @media only screen and (max-width: 750px) {
            width: 6.9rem;
            margin: 0 auto;
            padding: .3rem 0;
        }
    }
}
</style>
<style lang="scss">
.mine{
    .title{
        font-size: .2rem;
        font-weight: bold;
        margin-bottom: .3rem;
        @media screen and (max-width: 750px) {
            font-size: .3rem;
        }
    }
    .btn_bottom_group{
        gap: .4rem;
        padding-top: .8rem;
    }
    .btn_submit{
        width: .9rem;
        height: .4rem;
        border-radius: 0.1rem;
        background: #f0f0f0;
        font-size: .16rem;
        cursor: pointer;
        // box-shadow: 0 0 .07rem rgba($color: #000000, $alpha: .3);
        filter: drop-shadow(0 .02rem .01rem rgba($color: #000000, $alpha: .3)) drop-shadow(0 0 .02rem rgba($color: #000000, $alpha: .3));
        @media screen and (max-width: 750px) {
            font-size: .25rem;
            width: 1.4rem;
            height: .6rem;
        }
    }
    .loading_wrap,
    .no_more{
        padding: .8rem 0;
    }
    .no_more{
        a{
            color: var(--font_color);
            border-bottom: 1px solid var(--font_color);
        }
    }
    .form{
        display: flex;
        gap: .2rem;
        flex-direction: column;
        &.row{
            flex-wrap: wrap;
            flex-direction: row;
            width: auto;
            @media screen and (max-width: 750px) {
                flex-direction: column;
            }
            &.edit{
                .item{
                    &:nth-of-type(2n){
                        justify-content: flex-end;
                    }
                }
            }
        }
        .item{
            display: flex;
            align-items: center;
            font-size: .16rem;
            gap: 0 .1rem;
            @media screen and (max-width: 750px) {
                font-size: .25rem;
                gap: 0 .1rem;
            }
            .name{
                flex-shrink: 0;
                width: 1rem;
                // font-size: .16rem;
                line-height: .4rem;
                @media screen and (max-width: 750px) {
                    width: 1.5rem;
                }
            }
            .btn_code{
                height: .4rem;
                border-radius: .05rem;
                border: 1px solid var(--font_color);
                width: 1.1rem;
                cursor: pointer;
                flex-shrink: 0;
                @media screen and (max-width: 750px) {
                    height: .6rem;
                    width: 1.6rem;
                }
            }
            textarea{
                flex: 1;
                border: 1px solid var(--font_color);
                border-radius: .05rem;
                height: 2rem;
                padding: .1rem;
                font-size: .16rem;
                resize: none;
                &::placeholder{
                    color: #b2b2b2;
                }
                @media screen  and (max-width: 750px) {
                    height: 3rem;
                    font-size: .25rem;
                    padding: .2rem;
                }
            }
            input{
                &::placeholder{
                    color: #b2b2b2;
                }
                &[type=text],
                &[type=password],
                &[type=email],
                &[type=tel]{
                    width: 0;
                    flex: 1;
                    border: 1px solid var(--font_color);
                    border-radius: .05rem;
                    height: .4rem;
                    padding: 0 .1rem;
                    font-size: .16rem;
                    // &.code{
                    //     width: 2rem;
                    // }
                    @media screen and (max-width: 750px) {
                        height: .6rem;
                        font-size: .25rem;
                        padding: 0 .2rem;
                    }
                }
                &[type=radio],
                &[type=checkbox]{
                    appearance: none;
                    width: .16rem;
                    height: .16rem;
                    border: 1px solid var(--font_color);
                    border-radius: 50%;
                    position: relative;
                    cursor: pointer;
                    @media screen and (max-width: 750px) {
                        width: .24rem;
                        height: .24rem;
                    }
                    &:checked{
                        &::after{
                            content: "";
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            width: 60%;
                            height: 60%;
                            border-radius: 50%;
                            background: var(--font_color);
                        }
                    }
                }
            }
            .radio_group{
                height: .4rem;
                gap: .2rem;
                font-size: .16rem;
                @media screen and (max-width: 750px) {
                    height: .6rem;
                    font-size: .25rem;
                }
                &,
                .radio{
                    display: flex;
                    align-items: center;
                }
                .radio{
                    gap: .05rem;
                    line-height: 1;
                    cursor: pointer;
                }
            }
            // .select{
            //     flex: 1;
            //     width: auto;
            // }
            .btn{
                height: .4rem;
                padding: 0 .2rem;
                font-size: .16rem;
                border: 1px solid var(--font_color);
                border-radius: .05rem;
                cursor: pointer;
                line-height: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                &.disabled{
                    color: #fff;
                    background: #666;
                    border-color: #666;
                    cursor: auto;
                }
                @media screen and (max-width: 750px) {
                    height: .6rem;
                    font-size: .25rem;
                }
            }
        }
    }
    // .popup{
    //     position: fixed;
    //     top: 0;
    //     left: 0;
    //     width: 100%;
    //     height: 100%;
    //     background: rgba($color: #000000, $alpha: .7);
    //     z-index: 999;
    //     .in{
    //         width: 8.6rem;
    //         background: #fff;
    //         position: absolute;
    //         top: 50%;
    //         left: 50%;
    //         transform: translate(-50%, -50%);
    //         @media screen and (max-width: 750px) {
    //             width: 6.9rem;
    //         }
    //     }
    //     .btn_group{
    //         gap: .15rem;
    //     }
    //     .btn{
    //         height: .3rem;
    //         padding: 0 .1rem;
    //         font-size: .16rem;
    //         border: 1px solid var(--font_color);
    //         border-radius: .05rem;
    //         cursor: pointer;
    //         line-height: 1;
    //         display: flex;
    //         justify-content: center;
    //         align-items: center;
    //         &.disabled{
    //             color: #fff;
    //             background: #666;
    //             border-color: #666;
    //             cursor: auto;
    //         }
    //     }
    // }
}
</style>
